var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-list-page-wrapper"},[_vm._v(" Page AccountList ")])}
var staticRenderFns = []

export { render, staticRenderFns }